<template>
    <div class="text-sm w-full flex items-center truncate">
        <div class="flex-none">
            <hts-icons
                icon-name="hi-stop-icon"
                :color="color" />
        </div>
        <span class="flex-1 truncate">
            {{ label }}
        </span>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  status: {
    type: Number,
    required: true
  }
})

const { status } = toRefs(props)

const label = computed(() => {
  if (status.value === 0) {
    return $t('labels.notReadyYet')
  }
  if (status.value === 1) {
    return $t('labels.conditionallyReady')
  }
  if (status.value === 2) {
    return $t('labels.ready')
  }
  return 'Unknown'
})

const color = computed(() => {
  if (status.value === 0) {
    return 'gray'
  }
  if (status.value === 1) {
    return 'orange'
  }
  if (status.value === 2) {
    return 'green'
  }
  return 'Unknown'
})
</script>
